import { SystemTaskTypeReadable, taskTypesSystemListOptions } from '@crm/api'
import { useTableSorter } from '@crm/hooks/useTableSorter'
import { defaultFilters } from '@crm/utils'
import { DayLabel, TableContainer } from '@shared/components'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'

import { useMemo } from 'react'

import type { TableColumnsType } from 'antd'

export const NomenclaturesSystemTask = () => {
  const { t } = useLocales()
  const params = useQueryParams()

  const sorter = useTableSorter()

  const { data: systemTask, isLoading } = useQuery(
    taskTypesSystemListOptions({ query: { ...defaultFilters, ...params } })
  )

  const columns = useMemo(
    (): TableColumnsType<SystemTaskTypeReadable> => [
      {
        title: t('nomenclature.name'),
        key: 'name',
        sorter: true,
        render: ({ name }) => t(`system_task_code.${name}`)
      },
      {
        title: t('nomenclature.code_name'),
        dataIndex: 'code',
        key: 'code',
        sorter: true
      },
      {
        title: t('filter.created_at'),
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        render: (created_at) => <DayLabel date={created_at} />
      },
      {
        title: t('lead.modified_at'),
        dataIndex: 'modified_at',
        key: 'modified_at',
        sorter: true,
        render: (modified_at) => <DayLabel date={modified_at} />
      }
    ],
    [t]
  )

  return (
    <TableContainer
      data={systemTask}
      columns={columns}
      loading={isLoading}
      onChange={(_, __, result) => sorter(result)}
      bordered
    />
  )
}
